import { useQuery } from "@tanstack/react-query";
import { createFileRoute, useParams } from "@tanstack/react-router";
import { RecordWorkspaceFormPanel } from "@/features/records/components/record-workspace-form-panel";
import { recordInstanceQueryOptions } from "@/services/record";

export const Route = createFileRoute(
	"/_authenticated/(web-app)/_web/web/$orgId/tickets/(ticket)/$ticketId/workspace/records/$recordId/workspace/form",
)({
	component: RecordWorkspaceFormTab,
});

function RecordWorkspaceFormTab() {
	const params = useParams({
		from: "/_authenticated/(web-app)/_web/web/$orgId/tickets/(ticket)/$ticketId/workspace/records/$recordId/workspace/form",
	});
	const recordById = useQuery(
		recordInstanceQueryOptions.detail(params.recordId, {
			organizationId: params.orgId,
		}),
	);

	return (
		<RecordWorkspaceFormPanel
			record={recordById.data}
			recordId={params.recordId}
			organizationId={params.orgId}
			isRecordPending={recordById.isPending}
		/>
	);
}
